module.exports = __webpack_public_path__ + "img/登录图.c9757c6f.png";